import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";
import { Lightbulb, ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface ActivityInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ActivityInfoModal: React.FC<ActivityInfoModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl">
            {t("what_is_activity") || "What is an Activity?"}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          <div className="flex items-start gap-3">
            <Lightbulb className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
            <div>
              <p className="leading-relaxed text-gray-700">
                {t("activity_description") ||
                  "An activity is a guided step-by-step exercise that helps you think through a situation, understand your current patterns, and take clearer, more effective actions. Activities are designed to make your thinking visible, help you reflect, and support personal growth or better decision-making."}
              </p>
            </div>
          </div>

          {/* Marketplace Call-to-Action */}
          <div className="p-4 bg-gradient-to-r from-primary/5 to-primary/5 border border-primary/20 rounded-lg">
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <p className="text-sm font-semibold text-gray-900 mb-1">
                  {t("explore_more_activities") || "Explore More Activities"}
                </p>
                <p className="text-sm text-gray-700">
                  {t("marketplace_activities_message") ||
                    "Discover hundreds of activities in our marketplace designed to help you grow, learn, and make better decisions."}
                </p>
              </div>
              <Link
                to="/marketplace?tab=activities"
                onClick={onClose}
                className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors text-sm font-medium whitespace-nowrap"
              >
                {t("visit_marketplace") || "Visit Marketplace"}
                <ExternalLink className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ActivityInfoModal;
